import { commaizeNumber } from '@teamturing/utils';

const numberWithPercent = (value: number): string => `${Math.round((value as number) * 100 * 10000) / 10000}%`;

export { commaizeNumber as numberWithCommas, numberWithPercent };
